import { render, staticRenderFns } from "./LayoutContentRendererDefault.vue?vue&type=template&id=a02a2636&scoped=true"
import script from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js"
export * from "./LayoutContentRendererDefault.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentRendererDefault.vue?vue&type=style&index=0&id=a02a2636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02a2636",
  null
  
)

export default component.exports